"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcWorksheetEditorFieldset = class UcWorksheetEditorFieldset extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onRentalSelected(...args) {
        const { option, value } = args[0];
        if (option && option.client_id && option.client_name) {
            this.worksheet.client = {
                id: option.client_id,
                name: option.client_name
            };
        }
    }
    worksheet;
    onWorksheet(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("worksheet");
    }
    labelAlign;
    statuses;
    async $$load_statuses() {
        return this.$fn.getEnumValuesFromSchema('WorksheetStatus', { sort: false });
    }
    ux;
    b_8564662037462133_dataSource;
    b_3573211234170528_dataSource;
    b_6639903447389385_dataSource;
    b_8017867030266407_dataSource;
    dataMembers = ['labelAlign', 'statuses', 'ux', 'b_8564662037462133_dataSource', 'b_3573211234170528_dataSource', 'b_6639903447389385_dataSource', 'b_8017867030266407_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                statuses: null,
                ux: null,
                b_8564662037462133_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "own",
                    },
                },
                b_3573211234170528_dataSource: {
                    name: "suggest_rental",
                },
                b_6639903447389385_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                    },
                },
                b_8017867030266407_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                        contractors_only: true,
                    },
                },
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return this.worksheet === 'locked';
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_3573211234170528_script_8168_getActionArgs_value($event) {
        this.onRentalSelected($event.data);
    }
    async act_3573211234170528_script_8168_getActionArgs($event) {
        return {
            value: () => this.act_3573211234170528_script_8168_getActionArgs_value($event),
        };
    }
    async evh_3573211234170528_optionSelected(event, scope) {
        return await this.actions.evh_3573211234170528_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8166 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8165 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8166,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8165],
        });
        const act_3573211234170528_script_8168 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3573211234170528_script_8168_getActionArgs,
            events: [],
        });
        const evh_3573211234170528_optionSelected_8167 = new core_1.actions.EventHandlerImpl({
            action: act_3573211234170528_script_8168,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_3573211234170528_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3573211234170528_optionSelected_8167],
        });
        return {
            act_7315092382398562_reloadComponentData_8166,
            evh_7315092382398562_reload_8165,
            evh_7315092382398562_reload,
            act_3573211234170528_script_8168,
            evh_3573211234170528_optionSelected_8167,
            evh_3573211234170528_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcWorksheetEditorFieldset.prototype, "worksheet", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('worksheet'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcWorksheetEditorFieldset.prototype, "onWorksheet", null);
UcWorksheetEditorFieldset = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcWorksheetEditorFieldset);
exports.default = UcWorksheetEditorFieldset;
vue_property_decorator_1.Vue.component("UcWorksheetEditorFieldset", UcWorksheetEditorFieldset);
